<template>
    <el-drawer
    id="tools_list"
    title="统计"
    
    :visible.sync="drawer"
    :direction="direction"
    :withHeader="false"
    :before-close="handleClose"
    custom-class="full-screen-drawer"
   
  >
  <div class="header">
      <div class="title">统计</div>
      <div class="other">
        <el-button @click="onExport" type="primary" >导出</el-button>
        <el-button @click="onClose" type="danger">返回</el-button>
      </div>
    </div>
    <div class="content clearfix">
      <div class="content-item">
        <el-table
        ref="tableArr"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :row-style="{ height: '0' }"
        :cell-style="changeCellStyle"
      >
        <template v-for="item in items">
          <el-table-column v-if="item.id == 'index'" :label="item.name" :prop="item.id" 
                            width="120" align="center">
                            <template slot-scope="scope">
                                {{ scope.$index + 1 }}
                            </template>
                        </el-table-column>

            <el-table-column v-else-if="item.id == 'num'" :label="item.name" :prop="item.id" 
                width="120" align="center">
                <template slot-scope="scope">
                    <div :class="`title ${scope.row.color}`">
                        {{ scope.row.num }}
                    </div>
                </template>
            </el-table-column>

          <el-table-column
            v-else-if="item.id == 'tools'"
            header-align="center"
            align="center"
            :label="item.name"
            :prop="item.id"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.tools==0">
                <el-button @click="onChange(scope.$index,1)" type="primary">增加</el-button>
              </div>
              <div v-else>
                <el-button @click="onChange(scope.$index,0)" type="danger">减少</el-button>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column
            v-else-if="item.id == 'txt'"
            header-align="center"
            align="center"
            :label="item.name"
            :prop="item.id"
            width="100"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.txt" autocomplete="off" type="number" min="0" @change="onChangeTxt(scope.$index)"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="item.name"
            header-align="center"
            align="center"
            :label="item.name"
            :prop="item.id"
          ></el-table-column>
        </template>
       
      </el-table>
      </div>
      
    </div>
    </el-drawer>
  </template>
  
  <script>
  import * as XLSX from 'xlsx';
  import { saveAs } from 'file-saver';
  import { getColor } from "./num.js";

  export default {
    name: "movie_dialog",
    data() {
      return {
        drawer: false,
        items: [
            { name: "序号", id: "index" },
            { name: "号码", id: "num" },
            { name: "需投注", id: "value" },
            { name: "操作", id: "tools" },
            { name: "操作值", id: "txt" },
            { name: "投注", id: "complete" },
        ],
        tableData: [],
      };
    },
    methods: {
        onClose(){
            this.drawer = false;
            this.tableData = [];
        },
        onExport(){

            let values = [];
            this.tableData.forEach((item) => {
                values.push({
                    num: item.num,
                    value: item.value,
                    complete: item.complete,
                });
            })

            this.ExportExcel(values,'统计');
        },
        ExportExcel(tables,tableName){
            const ws = XLSX.utils.json_to_sheet(tables);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
            function s2ab(s) {
                const buf = new ArrayBuffer(s.length);
                const view = new Uint8Array(buf);
                for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                return buf;
            }
            const timestamp = new Date().getTime(); // 返回当前时间的毫秒表示
            let name = tableName + '-' + timestamp;
            saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), name+'.xlsx');

        },
        onChangeTxt(rowIndex) {
            console.log("rowindex:",rowIndex);
            let isAdd = this.tableData[rowIndex].tools;
            if(isAdd==0){   
                this.tableData[rowIndex].complete = parseInt(this.tableData[rowIndex].value) + parseInt(this.tableData[rowIndex].txt);
            }else{
                if(this.tableData[rowIndex].txt>this.tableData[rowIndex].value){
                    this.$message.error("操作值不能大于需投注");
                    this.tableData[rowIndex].txt = 0;
                }else{
                    this.tableData[rowIndex].complete = parseInt(this.tableData[rowIndex].value) - parseInt(this.tableData[rowIndex].txt);
                }
            }
        },
        onChange(rowIndex,type) {
            console.log("rowindex:",rowIndex);
            this.tableData[rowIndex].tools = type;
            // this.$refs.tableArr.clearSelection();
            // this.$refs.tableArr.toggleRowSelection(this.tableData[rowIndex],true);
        },
      show(values) {
        this.drawer = true;
       
        this.tableData = [];
        values.forEach((item) => {
          this.tableData.push({
            num: item.num,
            value: item.value,
            color:getColor(parseInt(item.num)),
            tools: 1,
            txt: 0,
            complete: item.value,
          });
        })

        console.log("tableData:",this.tableData);
      },
      changeCellStyle(value) {
            return 'height:30px;padding:0;background:white;text-align:center;'
        },
      onSubmit() {
        
      }
    }
  };
  </script>
  <style lang="less">
  #tools_list{
    font-size: 20px;
    color: black;
    .full-screen-drawer{  
      width: 40%;
    }
    .header {
        height: 60px;
        width: 100%;
        background-image: linear-gradient(to right, #0f6ad7, #00ced4);
        padding: 0 30px;
        box-sizing: border-box;
        color: white;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        line-height: 60px;
        display: flex;
        .title{
            flex:1;
        }
        .other{
            width:200px;
            flex:none;
        }
    }
    .content {
        width: 100%;
        // height:
        padding: 10px;
        box-sizing: border-box;
        .content-item {
            height:calc(100vh - 100px);
            overflow: scroll;
            width: 100%;
        }
        .title {
                font-size: 20px;
                font-weight: bold;

                &.red {
                    color: rgb(245, 140, 140);
                }

                &.blue {
                    color: rgb(118, 118, 242);
                }

                &.green {
                    color: rgb(64, 209, 64);
                }
            }
    }

    @media screen and (max-width: 768px){
      .full-screen-drawer
     {
        width: 100%  !important;
     }
    }
  }
  </style>